import * as React from 'react'
import { ComplianceStore, ComplianceStep } from './ComplianceStore'
import { Steps } from 'antd'

const stepsList: Array<{ step: ComplianceStep; label: string }> = [
  {
    step: ComplianceStep.LocationMonth,
    label: 'Location/month',
  },
  {
    step: ComplianceStep.Fix,
    label: 'Inventory corrections',
  },
  {
    step: ComplianceStep.Preview,
    label: 'Preview',
  },
  {
    step: ComplianceStep.Generate,
    label: 'Download',
  },
]

interface IProps {
  complianceStore: ComplianceStore
}

export class ComplianceNavigator extends React.Component<IProps, {}> {
  render() {
    const { complianceStore } = this.props

    return (
      <div className='p-4'>
        <Steps
          current={complianceStore.currentStep - 1}
          onChange={(current) => {
            complianceStore.toSpecificStep(current + 1)
          }}
        >
          {stepsList.map((step) => (
            <Steps.Step key={step.step} title={`Step ${step.step}`} description={step.label} />
          ))}
        </Steps>
      </div>
    )
  }
}
